import * as React from 'react';
import { SVGProps } from 'react';

const IconStopSizeXs = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M2 3h7v7H2z" />
  </svg>
);
export default IconStopSizeXs;
